package com.vizio.redwolf.pay.model

import kotlinx.serialization.Serializable

@Serializable
data class SerialNumberRequest(val serialNumber: String?)

@Serializable
data class CreateSupportCaseRequest(
    val phoneNumber: String,
    val firstName: String,
    val lastName: String,
    val email: String? = null,
    val modelNumber: String? = null,
    val serialNumber: String? = null,
    val notes: String? = null,
    val callCustomerBack: Boolean? = null
)
